import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { belongsTo } from '@apexdesigner/schema-tools';

export const interviewTeamwork = z
  .object({
    id: z.number().hidden().describe('Unique identifier'),

    teamworkScore: z
      .number()
      .nullable()
      .optional()
      .describe('Score for teamwork ability.'),

    leadershipScore: z
      .number()
      .nullable()
      .optional()
      .describe('Score for leadership qualities.'),

    notes: z
      .string()
      .nullable()
      .optional()
      .presentAs('textarea')
      .describe('Interviewer notes on teamwork and leadership.'),

    interviewId: z.number().hidden().describe('Foreign key to Interview'),

    interview: belongsTo('Interview'),
  })
  .describe('Teamwork and leadership scores from the candidate interview.')
  .as('InterviewTeamwork');

export { interviewTeamwork as interviewTeamworkSchema };
